module.exports = __webpack_public_path__ + "static/colorado-bg-1-dark-d98e632bd06aca221f83bf0dfc72cb39.jpg";